/***
 ***
 * 公共函数文件
 ***
 ***/


/**
 * 校验手机号的正则
 */
// export const isMobile = (element) => {
//   let patrn = /^0?1[0-9]{10}$/;
//   return patrn.test(element);
// };

export  const isMobile =(phone) =>{
  if (!(/^1[3456789]\d{9}$/.test(phone))) {
      return false;
  }
  return true;
}
/**
 * 校验邮箱的正则
 */
 export  const  isEmailAvailable =(emailInput) => {
  var myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
  if (!myreg.test(emailInput)) {
      return false;
  } else {
      return true;
  }
}



/**
 * 校验姓名的正则
 */
export const isCardName = (str) => {
  str = str.replace(/[\u4e00-\u9fa5]/g, 'aa');
  let patrn = /^([a-zA-Z])([a-zA-Z. ·]){0,48}([a-zA-Z])$/;
  if (str.length == '1') {
    patrn = /[a-zA-Z]/;
  }
  let flag = patrn.test(str);
  return flag;
};

/**
 * 收货地址去掉空格
 */
 export const isAdress = (str) => {
    var patt1 = new RegExp(/\s+/g);
    if (patt1.test(str)) {
        // alert("有空格");
    }
    let string = str.replace(/\s+/g, "");
    return string
};

/**
 * 元转分
 */
export const regYuanToFen = (yuan, digit) => {
  var m = 0,
    s1 = yuan.toString(),
    s2 = digit.toString();
  try { m += s1.split('.')[1].length; } catch (e) { }
  try { m += s2.split('.')[1].length; } catch (e) { }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
};

// 日期格式
export const showyd = (yyyy, mth, dd, hh, mm, ss) => {
  let date = new Date(yyyy, mth, dd, hh, mm, ss);
  console.log(date);
  let y = date.getFullYear();
  let m = (date.getMonth()) < 10 ? '0' + (date.getMonth()) : (date.getMonth());
  let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  return y + '-' + m + '-' + d + ' ' + h + ':00';
};

// 中文日期格式2
export const showchyd = (yyyy, mth, dd, hh, mm, ss) => {
  let date = new Date(yyyy, mth, dd, hh, mm, ss);
  let y = date.getFullYear();
  let m = (date.getMonth()) < 10 ? '0' + (date.getMonth()) : (date.getMonth());
  let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  return y + '年' + m + '月' + d + '日';
};
// 校验多证件的证件号
export const checkMultiCertificate = (certificateNo) => {
  let reg = /^[0-9A-Za-z]{5,18}$/
  return reg.test(certificateNo)
}

// 判断身份证格式
export const isIdCard = (card) => {
  let aCity = {11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外'}
  let iSum = 0
  let strIDno = card
  if (!/^\d{17}(\d|x)$/i.test(strIDno)) {
    return false // 非法身份证号
  }

  if (aCity[parseInt(strIDno.substr(0, 2))] == null) {
    return false// 非法地区
  }

  // 判断是否大于2078年，小于1900年
  let year = strIDno.substring(6, 10)
  if (year < 1900 || year > 2078) {
    return false// 非法生日
  }

  // 18位身份证处理

  // 在后面的运算中x相当于数字10,所以转换成a
  strIDno = strIDno.replace(/x$/i, 'a')

  let sBirthday = strIDno.substr(6, 4) + '-' + Number(strIDno.substr(10, 2)) + '-' + Number(strIDno.substr(12, 2))
  let d = new Date(sBirthday.replace(/-/g, '/'))
  if (sBirthday != (d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate())) {
    return false // 非法生日
  }
  // 身份证编码规范验证
  for (let i = 17; i >= 0; i--) {
    iSum += (Math.pow(2, i) % 11) * parseInt(strIDno.charAt(17 - i), 11)
  }
  if (iSum % 11 != 1) {
    return false// 非法身份证号
  }

  // 判断是否屏蔽身份证
  let words = ['11111119111111111', '12121219121212121']

  for (let k = 0; k < words.length; k++) {
    if (strIDno.indexOf(words[k]) != -1) {
      return false
    }
  }

  return true
}


// 获取userAgent的值，比如经纬度
export function getValue(name) {
  let str = navigator.userAgent;
  // let str = 'Mozilla/5.0 (Linux; Android 10; M2006J10C Build/QP1A.190711.020; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/83.0.4103.101 Mobile Safari/537.36 AgentWeb/4.1.3  UCBrowser/11.6.4.950 Jsmcc/1.0 Mall/1.0 ua=jsapp&ch=02&platform=android&lng=118.7773&lat=32.0828&cityCode=14&poi=%E6%B1%9F%E8%8B%8F%E7%9C%81%E5%8D%97%E4%BA%AC%E5%B8%82%E9%BC%93%E6%A5%BC%E5%8C%BA%E8%AE%B8%E5%BA%9C%E5%B7%B793%E5%8F%B7&version=8.2.2';
  // let str = 'Mozilla/5.0 (Linux; Android 8.1.0; DE106 Build/OPM1.171019.026; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/62.0.3202.84 Mobile Safari/537.36 AgentWeb/4.1.3  UCBrowser/11.6.4.950 Jsmcc/1.0 Mall/1.0 ua=jsapp&ch=02&platform=android&lng=118.7621&lat=32.0071&cityCode=14&poi=%E6%B1%9F%E8%8B%8F%E7%9C%81%E5%8D%97%E4%BA%AC%E5%B8%82%E9%9B%A8%E8%8A%B1%E5%8F%B0%E5%8C%BA%E5%87%A4%E5%8F%B0%E5%8D%97%E8%B7%AF415-5%E5%8F%B7&version=8.1.2'
  // 返回值
  let value = "";
  let arr = str.split(" ");
  arr.forEach(function (item) {
      if (item.indexOf(name) > -1) {
          let array = item.split("&");
          array.forEach(function (val) {
              if (val.indexOf(name + '=') > -1) {
                  let temp = val.split("=");
                  value = temp[1];
              }
          })
      }
  });

  return value;
}



// WEBPACK FOOTER //
// ./src/untils/tool.js